export function isNarrowScreen() {
  return (window.innerWidth || 0) < 1200
}
